import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialDetailState } from './initialState'
import { DetailTab } from './types'

const slice = createSlice({
  name: 'userLists/detail',
  initialState: initialDetailState,
  reducers: {
    setCurrentList: (state, action: PayloadAction<number | null>) => {
      state.currentListId = action.payload
    },
    setActiveTab: (state, action: PayloadAction<DetailTab>) => {
      state.activeTab = action.payload
    },
  },
})

export const reducer = slice.reducer
export const { setCurrentList, setActiveTab } = slice.actions

type UserListsRootState = {
  userLists: { detail: ReturnType<typeof reducer> }
}

export const selectCurrentListId = (state: UserListsRootState) =>
  state.userLists.detail.currentListId

export const selectActiveTab = (state: UserListsRootState) =>
  state.userLists.detail.activeTab

export type { DetailTab, DetailState } from './types'
